import { gql } from "@apollo/client";

export const REMOVE_ATTACHMENT = gql`
    mutation RemoveAttachment($attachmentId: ID!) {
        removeAttachment(attachmentId: $attachmentId) {
            id
            fileName
            tokens
            fileSize
            messageId
        }
    }
`;

